import request from '@utils/request'
import configRequest from "@src/config/request";

export const state = {};

export const mutations = {};

export const getters = {};

export const actions = {
  /**
   * 取得會員優惠券列表
   * @param commit
   * @param eventAlias
   * @param limit
   * @param page
   * @returns {AxiosPromise<any>}
   */
  fetchCouponList({ commit }, {
    eventAlias,
    limit = 4,
    page = 1
  } = {}) {
    return request
      .post(`/coupon/search`, {
        eventAlias,
        limit,
        page
      }, {
        ...configRequest,
        name: 'fetchCouponList'
      })
  },

  /**
   * 檢查優惠券
   * @param commit
   * @param code
   * @param eventAlias
   * @returns {AxiosPromise<any>}
   */
  checkCoupon({ commit }, {
    code,
    eventAlias,
  }) {
    return request
      .post('/coupon/checkUsable', {
        code,
        eventAlias,
      }, {
        ...configRequest,
        name: 'checkCoupon'
      })
  },
};
